import { createPurchaseOrderFormInitialValues } from '../../data/purchaseOrderConstants';

export function getInitialPurchaseOrderActiveView() {
  return 'list';
}

export function buildPurchaseOrderEditValues(purchaseOrder) {
  return {
    poDate: purchaseOrder.poDate,
    supplierId: String(purchaseOrder.supplierId),
    quantity: String(purchaseOrder.quantity),
    price: String(purchaseOrder.price ?? ''),
    warehouseLocation: purchaseOrder.warehouseLocation || '',
    actualPrice:
      purchaseOrder.actualPrice === null || typeof purchaseOrder.actualPrice === 'undefined'
        ? ''
        : String(purchaseOrder.actualPrice),
    receivedQuantity:
      purchaseOrder.receivedQuantity === null ? '' : String(purchaseOrder.receivedQuantity),
    stockUnit: purchaseOrder.stockUnit,
    lansaName: purchaseOrder.lansaName,
    sacksMark: purchaseOrder.sacksMark,
    deliveryDate: purchaseOrder.deliveryDate,
    seaweedType: purchaseOrder.seaweedType || '',
    status: purchaseOrder.status,
    balancingReadyAt: purchaseOrder.balancingReadyAt || '',
  };
}

export function getInitialProgressValues(purchaseOrder) {
  return {
    status: getNextProgressStatus(purchaseOrder.status),
    actualPrice: String(purchaseOrder.actualPrice ?? purchaseOrder.price ?? ''),
    receivedQuantity: String(purchaseOrder.receivedQuantity ?? purchaseOrder.quantity),
    lansaName: purchaseOrder.lansaName || '',
    warehouseLocation: purchaseOrder.warehouseLocation || '',
    deliveryDate: purchaseOrder.deliveryDate || '',
  };
}

export function createEmptyProgressValues() {
  return {
    status: '',
    actualPrice: '',
    receivedQuantity: '',
    lansaName: '',
    warehouseLocation: '',
    deliveryDate: '',
  };
}

export function validatePurchaseOrderForm(values, options = {}) {
  const {
    requireWarehouseLocation = true,
    requireDeliveryDate = true,
    requireSeaweedType = true,
  } = options;
  const errors = {};
  const quantity = Number(values.quantity);
  const price = Number(values.price);
  const actualPrice = Number(values.actualPrice);

  if (!values.poDate) {
    errors.poDate = 'P.O. date is required.';
  }

  if (!values.supplierId) {
    errors.supplierId = 'Supplier is required.';
  }

  if (values.quantity === '' || !Number.isFinite(quantity) || quantity <= 0) {
    errors.quantity = 'Enter a valid quantity greater than zero.';
  }

  if (values.stockUnit === 'sacks' && Number.isFinite(quantity) && !Number.isInteger(quantity)) {
    errors.quantity = 'Sacks quantity must be a whole number.';
  }

  if (values.price === '' || !Number.isFinite(price) || price < 0) {
    errors.price = 'Enter a valid price of zero or greater.';
  }

  if (requireWarehouseLocation && !values.warehouseLocation?.trim()) {
    errors.warehouseLocation = 'Warehouse is required.';
  }

  if (
    values.actualPrice !== '' &&
    (!Number.isFinite(actualPrice) || actualPrice < 0)
  ) {
    errors.actualPrice = 'Enter a valid actual price of zero or greater.';
  }

  if (!values.sacksMark.trim()) {
    errors.sacksMark = 'Sacks mark is required.';
  }

  if (requireDeliveryDate && !values.deliveryDate) {
    errors.deliveryDate = 'Delivery date is required.';
  }

  if (requireSeaweedType && !values.seaweedType?.trim()) {
    errors.seaweedType = 'Seaweed type is required.';
  }

  return errors;
}

export function normalizePurchaseOrderPayload(values) {
  return {
    poDate: values.poDate,
    supplierId: Number(values.supplierId),
    quantity: Number(values.quantity),
    price: Number(values.price),
    warehouseLocation: String(values.warehouseLocation || '').trim(),
    actualPrice: values.actualPrice === '' ? null : Number(values.actualPrice),
    receivedQuantity:
      values.receivedQuantity === '' ? null : Number(values.receivedQuantity),
    stockUnit: values.stockUnit,
    lansaName: values.lansaName.trim(),
    sacksMark: values.sacksMark.trim(),
    deliveryDate: values.deliveryDate || null,
    seaweedType: String(values.seaweedType || '').trim(),
    status: values.status,
  };
}

export function resetPurchaseOrderFormState(setFormValues, setFormErrors, setSubmitError) {
  setFormValues(createPurchaseOrderFormInitialValues());
  setFormErrors({});
  setSubmitError('');
}

export function getNextProgressStatus(currentStatus) {
  if (currentStatus === 'Initial') {
    return 'In Progress';
  }

  if (currentStatus === 'In Progress') {
    return 'In Progress';
  }

  if (currentStatus === 'Received') {
    return 'Completed';
  }

  return currentStatus;
}

export function formatPurchaseOrderQuantity(value, stockUnit) {
  const numericValue = Number(value ?? 0);
  const formattedValue =
    stockUnit === 'kg'
      ? numericValue.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      : numericValue.toLocaleString('en-US', {
          maximumFractionDigits: 0,
        });

  return `${formattedValue} ${stockUnit === 'kg' ? 'kg' : 'sacks'}`;
}

export function formatPurchaseOrderPrice(value) {
  return Number(value ?? 0).toLocaleString('en-PH', {
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function getPurchaseOrderQuantityStep(stockUnit) {
  return stockUnit === 'kg' ? '0.01' : '1';
}

export function getSupplierSacksMark(supplierId, supplierOptions) {
  const selectedSupplier = supplierOptions.find(
    (supplierOption) => String(supplierOption.value) === String(supplierId)
  );

  return selectedSupplier?.sacksMark || '';
}
